import React from "react";

// import Layout1 from "../pages/Home/Layout1/Layout1";
// import Layout2 from "../pages/Home/Layout2/Layout2";
// import Layout3 from "../pages/Home/Layout3/Layout3";

//Company Section
import AboutUs from "../pages/Company/AboutUs/AboutUs";
import Services from "../pages/Company/Services/Services";
import Team from "../pages/Company/Team/Team";
import Pricing from "../pages/Company/Pricing/Pricing";
import PrivacyAndPolicy from "../pages/Company/PrivacyAndPolicy/PrivacyAndPolicy";
import Faqs from "../pages/Company/Faqs/Faqs";

import VesselCanvasPage from "../pages/Vessels/VesselOffCanvas.js";

//Dashboard
import Dashboard from "../pages/Dashboards/Dashboards/BoatOwner/Dashboard.js";
import MyStockPage from "../pages/Dashboards/Dashboards/BoatOwner/MyStock.js";
import OrderDashboard from "../pages/Dashboards/Dashboards/BoatOwner/OrderDashboard.js";
import BoatInspectorDashboard from "../pages/Dashboards/Dashboards/BoatInspector/BoatInspector.js";
import BuyerDashboard from "../pages/Dashboards/Dashboards/BuyerDashboard/BuyerDashboard.js";
import PlantOwnerDashboard from "../pages/Dashboards/Dashboards/PlantOwner/Dashboard.js";
import TruckTracking from "../pages/Dashboards/Dashboards/TruckDriver/TruckTracking.js";
import CourierDashboard from "../pages/Dashboards/Dashboards/CourierDashboard/Dashboard.js";
import DfarDashboard from "../pages/Dashboards/Dashboards/DFAR/DfarDashboard.js";

//Jobs Section
import OrderList from "../pages/Orders/OrderList";

import AllStock from "../pages/Stocks";
import JobList from "../pages/Jobs/JobList2/JobList2";
import JobGrid from "../pages/Jobs/JobGrid/JobGrid";
import JobGrid2 from "../pages/Jobs/JobGrid2/JobGrid2";
import JobDetails from "../pages/Jobs/JobDetails/JobDetails";

import Checkout from "../pages/Checkout/Checkout";

import JobsCategories from "../pages/Jobs/JobsCategories/JobsCategories";
import Stockdetails from "../pages/Stocks/stockDetails.js";

//Candidate and Company Section

import CandidateList1 from "../pages/CandidateAndCompany/CandidateList/CandidateDetails";
import BoatOwnerList from "../pages/BoatOwner/BoatOwnerList";
import CandidateGrid from "../pages/CandidateAndCompany/CandidateGrid/CandidateGrid";
import CandidateDetails from "../pages/CandidateAndCompany/CandidateDetails/CandidateDetails";
import BoarOwnerDetails from "../pages/BoatOwner/BoatOwnerDetails";
import VesselDetails from "../pages/CandidateAndCompany/VesselDetails/VesselDetails";
import CompanyList from "../pages/CandidateAndCompany/CompanyList/CompanyList";
import CompanyDetails from "../pages/CandidateAndCompany/CompanyDetails/CompanyDetails";
import ProcessingPlantList from "../pages/CandidateAndCompany/ProcessingPlant/ProcessingPlantList.js";
import ProcessingPlantDetails from "../pages/CandidateAndCompany/ProcessingPlant/ProcessingPlantDetails";
import ProcessingplantStockAccept from "../pages/CandidateAndCompany/ProcessingPlant/processingplantStockAccept.js";
import AddProcessingCost from "../pages/CandidateAndCompany/ProcessingPlant/AddProcessingCost.js";

import CourierDetails from "../pages/CandidateAndCompany/Courier/CourierDetails";
import CourierList from "../pages/CandidateAndCompany/Courier/CourierList";
import Cof from "../pages/CandidateAndCompany/cof/Cof";
import CourierStockAccept from "../pages/CandidateAndCompany/Courier/CourierAccept.js";

//Blog Section
import Blog from "../pages/Blog/Blog/Blog";
import BlogGrid from "../pages/Blog/BlogGrid/BlogGrid";
import BlogModern from "../pages/Blog/BlogModern/BlogModern";
import BlogMasonary from "../pages/Blog/BlogMasonary/BlogMasonary";
import BlogDetails from "../pages/Blog/BlogDetails/BlogDetails";
import BlogAuther from "../pages/Blog/BlogAuther/BlogAuther";

//Contacts
import Contact from "../pages/Contact/Contact";

//AuthPages
import SignIn from "../pages/ExtraPages/SignIn";
import SignUp from "../pages/ExtraPages/SignUp";
import SignOut from "../pages/ExtraPages/SignOut";
import ResetPassword from "../pages/ExtraPages/ResetPassword";
import ComingSoon from "../pages/ExtraPages/ComingSoon";
import Error404 from "../pages/ExtraPages/Error404";
import Components from "../pages/ExtraPages/Components/Components";

//profile section(User Profile)
import BookMarkJobPost from "../pages/Profile/BookMarkJobPost/BookMarkJobPost";
import ManageOrders from "../pages/Profile/ManageOrders/ManageOrders";
import OrderDetails from "../pages/Profile/ManageOrders/OrderDetails";
import ManageStocks from "../pages/Profile/ManageOrders/ManageStocks";
import BookMark from "../pages/Profile/BookMark/BookMark";
import MyProfile from "../pages/Profile/MyProfile/MyProfile";

import OrderTracking from "../pages/Orders/OrderTracking";
import MyWallet from "../pages/Wallet/MyWallet";
import QrScanner from "../pages/QrScanner/qrscanner";
import COFRequest from "../pages/COFRequest/cofrequest";

import StockForm from "../pages/Stocks/StockPage.js";
import MyCart from "../pages/Cart/MyCart.js";
import ConfirmDeparture from "../pages/Departure/ConfirmDeparture.js";
import QualityInspect from "../pages/Quality/QualityInspect.js";
import VesselForm from "../pages/Vessels/VesselDetails";
import Wallet from "../pages/Wallet/MyWallet.js";
import ScannedFishDetails from "../pages/Scan/ScannedFishDetails.js";

//Home Section

const userRoutes = [
  //Components orders
  {
    path: "/ordertracking/:order_id/:stock_id/:trip_id",
    component: <OrderTracking />,
    protected: true,
    allowedRoles: ["buyer"],
  },

  { path: "/scan/:id", component: <ScannedFishDetails /> },

  //profile Section(User Profile)
  // { path: '/bookmarkjobpost', component: <BookMarkJobPost /> },
  {
    path: "/myprofile",
    component: <MyProfile />,
    protected: true,
    allowedRoles: [
      "buyer",
      "boat_owner",
      "boat_inspector",
      "processing_plant",
      "courier",
      "truck_driver",
    ],
  },
  {
    path: "/bookmark",
    component: <BookMark />,
    protected: true,
    allowedRoles: ["buyer"],
  },
  // { path: '/myorders', component: <ManageOrders /> },
  // { path: '/mystocks', component: <ManageStocks /> },
  { path: "/cof/:requestId/:vesselNumber", component: <Cof /> },

  //Vessel Section
  // { path: '/vesseloffcanvas', component: <VesselCanvasPage /> },

  //Components Section(Extra Pages)
  // { path: '/components', component: <Components /> },

  //Contact
  { path: "/contact", component: <Contact /> },
  {
    path: "/mywallet/:id",
    component: <MyWallet />,
    protected: true,
    allowedRoles: ["buyer"],
  },

  // Blog Section
  // { path: '/blogauther', component: <BlogAuther /> },
  // { path: '/blogdetails', component: <BlogDetails /> },
  // { path: '/blogmodern', component: <BlogModern /> },
  // { path: '/blogmasonary', component: <BlogMasonary /> },
  // { path: '/bloggrid', component: <BlogGrid /> },
  // { path: '/blog', component: <Blog /> },

  //Dashboards
  {
    path: "/BoatOwnerDashboard",
    component: <Dashboard />,
    protected: true,
    allowedRoles: ["boat_owner"],
  },
  {
    path: "/MyStockPage",
    component: <MyStockPage />,
    protected: true,
    allowedRoles: ["boat_owner"],
  },
  {
    path: "/OrderDashboard",
    component: <OrderDashboard />,
    protected: true,
    allowedRoles: ["boat_owner"],
  },
  {
    path: "/BoatInspectorDashboard",
    component: <BoatInspectorDashboard />,
    protected: true,
    allowedRoles: ["boat_inspector"],
  },
  {
    path: "/BuyerDashboard",
    component: <BuyerDashboard />,
    protected: true,
    allowedRoles: ["buyer"],
  },
  {
    path: "/PlantDashboard",
    component: <PlantOwnerDashboard />,
    protected: true,
    allowedRoles: ["processing_plant"],
  },
  {
    path: "/CourierDashboard",
    component: <CourierDashboard />,
    protected: true,
    allowedRoles: ["courier"],
  },
  // {
  //   path: '/DfarDashboard',
  //   component: <DfarDashboard />,
  // },

  //Candidate and Company Section

  // { path: '/buyerdetails/:id', component: <CompanyDetails /> },
  // { path: '/processingplant/:id', component: <ProcessingPlantDetails /> },
  { path: "/processingplantlist", component: <ProcessingPlantList /> },
  {
    path: "/truckTracking/:truckDriverid/:stockNo/:tripId",
    component: <TruckTracking />,
    protected: true,
    allowedRoles: ["processing_plant", "truck_driver", "buyer"],
  },

  // { path: '/courierdetails/:id', component: <CourierDetails /> },
  { path: "/courierlist", component: <CourierList /> },
  // { path: '/companylist', component: <CompanyList /> },
  //{ path: '/boatownerdetails/:id', component: <CandidateDetails /> },
  // { path: '/boatownerdetails/:id', component: <BoarOwnerDetails /> },

  // { path: '/vesseldetails/:id', component: <VesselDetails /> },
  // { path: '/candidategrid', component: <CandidateGrid /> },

  {
    path: "/wallet/:id",
    component: <Wallet />,
    protected: true,
    allowedRoles: ["buyer"],
  },

  //{ path: '/boatownerlist', component: <CandidateList1 /> },
  { path: "/boatownerlist", component: <BoatOwnerList /> },

  //Jobs Section

  // { path: '/jobscategories', component: <JobsCategories /> },
  { path: "/stockdetails/:id", component: <Stockdetails /> },
  // { path: '/orderdetails/:id', component: <OrderDetails /> },
  {
    path: "/checkout",
    component: <Checkout />,
    protected: true,
    allowedRoles: ["buyer"],
  },
  // { path: '/stocks1', component: <JobGrid2 /> },
  // { path: '/jobgrid', component: <JobGrid /> },
  // { path: '/joblist', component: <JobList /> },
  { path: "/stocks", component: <AllStock /> },
  // { path: '/orderList', component: <OrderList /> },
  // { path: '/orderList', component: <OrderList /> },
  {
    path: "/addStock",
    component: <StockForm />,
    protected: true,
    allowedRoles: ["boat_owner"],
  },
  {
    path: "/addStock/:id",
    component: <StockForm />,
    protected: true,
    allowedRoles: ["boat_owner"],
  },

  //Company Section
  // { path: '/faqs', component: <Faqs /> },
  // { path: '/privacyandpolicy', component: <PrivacyAndPolicy /> },
  // { path: '/pricing', component: <Pricing /> },
  // { path: '/team', component: <Team /> },
  // { path: '/services', component: <Services /> },
  // { path: '/aboutus', component: <AboutUs /> },

  //Home Section
  // { path: '/layout3', component: <Layout3 /> },
  // { path: '/layout2', component: <Layout1 /> },

  { path: "/qrscanner", component: <QrScanner /> },
  {
    path: "/cofrequest",
    component: <COFRequest />,
    protected: true,
    allowedRoles: ["boat_owner"],
  },
  // { path: '/my-cart', component: <MyCart /> },
  {
    path: "/confirmDeparture",
    component: <ConfirmDeparture />,
    protected: true,
    allowedRoles: ["boat_inspector"],
  },
  {
    path: "/qualityInspect",
    component: <QualityInspect />,
    protected: true,
    allowedRoles: ["boat_inspector"],
  },
  {
    path: "/addVessel",
    component: <VesselForm />,
    protected: true,
    allowedRoles: ["boat_owner"],
  },
];

const authRoutes = [
  { path: "/error404", component: <Error404 /> },
  { path: "/comingsoon", component: <ComingSoon /> },
  { path: "/resetpassword", component: <ResetPassword /> },
  { path: "/signout", component: <SignOut /> },
  { path: "/signup", component: <SignUp /> },
  { path: "/signin", component: <SignIn /> },
];
export { userRoutes, authRoutes };
